import React, { useState } from 'react';
import classes from "./Header.module.css";
import { useDispatch, useSelector } from 'react-redux';
import MobileMenu from './MobileMenu';
import { removeCredentials } from '../store/slices/credentialsSlice';
import { useNavigate } from 'react-router-dom';

const Header = ({ serviceDetails , active}) => {
    const { credentials } = useSelector(state => state.credentialsSlice);
    const [showDropdown, setShowDropdown] = useState(false);
    const [mobileMenu, setMobileMenu] = useState(false);
    const dispatch=useDispatch();
    const navigate=useNavigate();

    const showMobileMenuHandler = () => {
        setMobileMenu(true);
    };

    const hideMobileMenuHandler = () => {
        setMobileMenu(false);
    };

    const dropdownHandler = () => {
        setShowDropdown((prevValue) => !prevValue);
    };

    const handleLogout = () => {
        dispatch(removeCredentials());
        navigate("/");
    }
    return (
        <>
            <header className={classes.header}>

                <div className={classes.header_info}>
                    <div className={classes.menu}>
                        <i
                            className={`pi pi-bars ${classes.menu_icon}`}
                            onClick={showMobileMenuHandler}
                        ></i>
                    </div>
                    <h1 className={classes.header_service_text}>{credentials?.client_name}</h1>
                    {serviceDetails && 
                    <p className={classes.header_text}>{serviceDetails?.service_name ?? "Service Name"} / {serviceDetails?.country ?? "Country"} / {serviceDetails?.operator ?? "Operator"}</p>
                    }
                </div>

                <div className={classes.header_avatar} onClick={dropdownHandler}>
                    <img
                        src="/assets/images/avatar.png"
                        alt="Avatar"
                        className={classes.avatar}
                    />
                    {showDropdown ? (
                        <i className={`pi pi-chevron-up ${classes.avatar_icon}`}></i>
                    ) : (
                        <i className={`pi pi-chevron-down ${classes.avatar_icon}`}></i>
                    )}
                </div>

                <div className={`${classes.dropdown} ${showDropdown && classes.show}`}>
                    <div className={classes.dropdown_sub_container}>
                        <div className={classes.user}>
                            <i className={`pi pi-user ${classes.user_icon}`}></i>
                            <p className={classes.dropdown_client_name}>{credentials?.client_name}</p>
                        </div>
                        <div className={classes.underline}></div>
                        <button
                            className={classes.logout_btn}
                            onClick={() => {
                                handleLogout();
                            }}
                        >
                            <i className={`pi pi-power-off ${classes.logout_icon}`}></i>
                            Logout
                        </button>
                    </div>
                </div>

            </header>
            <MobileMenu
                active={active}
                mobileMenu={mobileMenu}
                hideMobileMenuHandler={hideMobileMenuHandler}
            />
        </>
    )
}

export default Header